import { getProjectName } from 'lib/get-project-name'
import React, { FC } from 'react'
import { TooltipProps } from 'react-tooltip'
import styled from 'styled-components'

import { Label, LabelProps } from '../../label'

export type Props = {
  labels: Array<LabelProps>
  tooltipSettings?: TooltipProps
}

export const Labels: FC<Props> = ({ labels = [], tooltipSettings }) => {
  return (
    <Wrapper>
      {labels.map((label) =>
        label.hidden ? (
          !label.hidden && (
            <LabelWrapper key={label.text}>
              <Label {...label} tooltipSettings={tooltipSettings} />
            </LabelWrapper>
          )
        ) : (
          <LabelWrapper key={label.text}>
            <Label {...label} tooltipSettings={tooltipSettings} />
          </LabelWrapper>
        )
      )}
    </Wrapper>
  )
}

const Wrapper = styled.div`
  display: flex;
  position: absolute;
  top: ${({ theme }) => theme.spacing[4]};
  left: ${({ theme }) => theme.spacing[4]};
  flex-wrap: wrap;
  z-index: 4;
  ${({}) =>
    getProjectName() === 'generic_v2' &&
    `
      flex-direction: column;
      right: 0;
      gap: 5px;
  `}
`

const LabelWrapper = styled.div`
  display: inline-block;
  margin-right: ${({ theme }) => theme.spacing[1]};
  margin-bottom: ${({ theme }) => theme.spacing[1]};
  ${({}) =>
    getProjectName() === 'generic_v2' &&
    `
      width: auto;
      margin-left: auto;
  `}
`
